// 首次重连仍平均3秒；仅打散集体掉线后的握手，不改变身份恢复或退出规则。
export const reconnectDelay = (random = Math.random) =>
  2500 + Math.floor(Math.max(0, Math.min(1, random())) * 1000);
